import { TableFilter } from "@neonumy/ant-design";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { Button, Card, Row } from "antd";
import CardTitle from "components/CardTitle";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRight, FaCalculator } from "react-icons/fa";
import { useParams } from "react-router-dom";
import useSales from "../hooks/useSales";
import useSalesVATTableColumns from "../hooks/useSalesVATTableColumns";
import CreateUpdateSaleVat from "./components/CreateUpdateSaleVat";

interface SalesVATPropsTypes {
  nextButton?: () => void;
  prevButton?: () => void;
}
export default function SalesVAT(props: SalesVATPropsTypes): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const paginationInit = {
    offset: 0,
    limit: 10,
  };
  const { nextButton } = props;
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    refetchListProductAccountingConfig: refetch,
    loadingListProductAccountingConfig: loading,
    productsAccountingTotalCount: totalCount,
    productsAccountingData: dataSource,
    listProductAccountingConfig,
  } = useSales();

  const COLUMNS = useSalesVATTableColumns(refetch);

  useEffect(() => {
    if (urlParams.companyId) {
      listProductAccountingConfig({
        variables: {
          filter: {
            companyId: urlParams.companyId,
          },
          ...paginationInit,
        },
      });
    }
  }, [urlParams.companyId]);

  const handlePagination = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(page);
    refetch({
      limit: size,
      offset: size * (page - 1),
    });
  };

  return (
    <>
      <Card
        title={<CardTitle icon={<FaCalculator />} title={t("Sales VAT")} />}
        className="antd-newrai-card"
      >
        <TableFilter
          className="antd-newrai-table"
          size="small"
          scroll={{ y: windowHeight - 550 }}
          dataSource={dataSource}
          loading={loading}
          columns={COLUMNS}
          pagination={{
            onChange: handlePagination,
            showSizeChanger: true,
            current: currentPage,
            pageSize: pageSize,
            total: totalCount,
            showTotal: total => t("Total table items", { count: total }),
          }}
          debounced={true}
        />
        <CreateUpdateSaleVat refetch={refetch} />
      </Card>

      {nextButton && (
        <Row justify="end">
          <Button
            type="primary"
            className="save-btn"
            onClick={() => nextButton()}
            icon={<FaArrowRight />}
          >
            {t("Next")}
          </Button>
        </Row>
      )}
    </>
  );
}
